import { now } from '@/utils'

export default {
  computed: {
    currLocale () {
      return this.$i18n.locale
    }
  },

  methods: {
    /**
     * @typedef {Object} ExpandedDate
     * @property {number} second
     * @property {number} minute
     * @property {number} hour
     * @property {number} day
     * @property {number} month
     * @property {number} year
     */

    /**
     * @param {Date} date
     * @returns {ExpandedDate}
     */
    expandDate (date) {
      return {
        second: date.getSeconds(),
        minute: date.getMinutes(),
        hour: date.getHours(),
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear()
      }
    },
    /**
     * @param {Object[]} array
     * @param {string} key — Date property key
     * @param {number=} itemSize
     * @param {number=} itemGroupSize
     * @returns {Object[]}
     */
    groupByDate (array, key, itemSize, itemGroupSize) {
      const today = this.expandDate(now)
      const yesterday = (() => {
        const localDate = new Date(now)
        localDate.setDate(localDate.getDate() - 1)
        return this.expandDate(localDate)
      })()

      return array.map((item, index, arr) => {
        const incomingDate = new Date(item[key])
        const createdDate = this.expandDate(new Date(item[key]))

        const isToday = today.year === createdDate.year && today.month === createdDate.month && today.day === createdDate.day
        const isYesterday = yesterday.year === createdDate.year && yesterday.month === createdDate.month && yesterday.day === createdDate.day
        const isPreviousYear = today.year !== createdDate.year

        item.createdAtString = `${incomingDate.getFullYear()}-${incomingDate.getMonth() + 1}-${incomingDate.getDate()}`
        item.groupDate = null
        item.size = itemSize || 73
        item.listId = `${item.id}-${index}`
        // item.listId = `${index}`

        if (index === 0 || arr[index - 1].createdAtString !== item.createdAtString) {
          item.size = itemGroupSize || 120

          if (isToday) {
            item.groupDate = this.$i18n.t('widgets.period.today')
          }

          if (isYesterday) {
            item.groupDate = this.$i18n.t('widgets.period.yesterday')
          }

          const dateStringOptions = {}
          if (isPreviousYear) {
            dateStringOptions.day = 'numeric'
            dateStringOptions.month = 'long'
            dateStringOptions.year = 'numeric'

            item.groupDate = incomingDate.toLocaleString(this.currLocale, dateStringOptions)
          }

          dateStringOptions.day = 'numeric'
          dateStringOptions.weekday = 'long'
          dateStringOptions.month = 'long'

          item.groupDate = incomingDate.toLocaleString(this.currLocale, dateStringOptions)
        }

        return item
      })
    }
  }
}
